import { DMCObject } from "./DMCObject";
import Konva from "konva";
import store from "../../../store/store";

// TOOLS
const pathInfo = require("path");

export class DMCImage extends DMCObject {
  constructor(name, konvaObject, source, sourceRatio = []) {
    super(name, konvaObject);

    if (name === undefined || konvaObject === undefined) {
      return;
    }
    this.source = source;
    this.sourceRatio = sourceRatio;
    this.tryLoad = 0;
    this.animation = null;
    this.animationRender = null;
    this.imageCount = 0;
    this.sliderTime = 5000;
    this.nextCycle = this.sliderTime;

    // On init setup check if multiple pictures and start slideshow
    if (this.source.length > 1) {
      this.initSlider();
    }
  }

  changeImageSource(urlImage) {
    let currentImage = new Image();
    currentImage.src = urlImage.replace("public\\", "");
    this.konvaObject.image(currentImage);
  }

  copyOption(DMCObject, controllerProject) {
    let newOption = super.copyOption(DMCObject, controllerProject);
    let currentImage = new Image();

    currentImage.src = this.loadCorrectSource(DMCObject);
    newOption.image = currentImage;
    return newOption;
  }

  /**
   * This method is called during loading to recreate the correct object type and load it into the controller.
   * @param {DMCObject} DMCObject
   */
  createNewObject(DMCObject) {
    return new Konva.Image(DMCObject.konvaObjectOption);
  }

  delete() {
    if (this.animation != null && this.animation !== undefined) {
      this.animation.stop();
    }
  }

  deselect() {
    if (this.animation != null && this.animation !== undefined) {
      this.animation.stop();
    }
  }

  getType() {
    return "Image";
  }

  loadCorrectSource(DMCObject) {
    this.source = [];
    const nameDir = pathInfo.basename(DMCObject.projectPath);

    DMCObject.source.forEach((src) => {
      // TODO: Beware dirs.app before it was dirs.root but it doesn't work on player mode
      const imgPath =
        store.state.config.dirs.app + "temp/readingDirectory/projects/" + nameDir + "/media/" + pathInfo.basename(src);
      this.source.push(imgPath);
    });

    if (store.state.config.system.isCreation) {
      this.source = DMCObject.source;
    }

    if (this.source.length > 0) {
      return this.source[0];
    } else {
      return "";
    }
  }

  load(controllerProject, DMCObject, incorporate) {
    this.animation = null;
    super.load(controllerProject, DMCObject, incorporate);

    // Restore properties
    this.sliderTime = DMCObject.sliderTime;
    this.tryLoad = 0;
    this.imageCount = 0;
    this.nextCycle = this.sliderTime;
    this.loadCorrectSource(DMCObject);
    return this;
  }

  loadEnd(obj) {
    this.initSlider();
    return obj;
  }

  options() {
    return ["Rect", "Image"];
  }

  nextImageCount() {
    this.imageCount = this.imageCount + 1;

    if (this.imageCount >= this.source.length) {
      this.imageCount = 0;
    }

    return this.imageCount;
  }

  renderChangeImageSource(urlImage, konvaObject) {
    let currentImage = new Image();
    currentImage.src = urlImage;
    konvaObject.image(currentImage);
  }

  renderSlider(layer, konvaObject) {
    if (this.source.length > 1 && konvaObject != null) {
      this.nextCycleRender = this.sliderTime;
      this.sliderTimeRender = this.sliderTime;

      this.timeBeforeAnimationRender = 0;
      this.animationRender = new Konva.Animation((frame) => {
        this.timeBeforeAnimationRender = frame.time;
        if (this.timeBeforeAnimationRender > this.nextCycleRender) {
          this.nextCycleRender += this.sliderTimeRender;
          this.renderChangeImageSource(this.source[this.nextImageCount()], konvaObject);
        }
      }, layer);

      this.animationRender.start();
    }
  }

  save() {
    return this.source;
  }

  select() {
    if (this.animation != null && this.animation !== undefined) {
      this.animation.start();
    }
  }

  initSlider() {
    if (this.source.length > 1 && this.konvaObject != null) {
      let timeBeforeAnimation = 0;
      this.animation = new Konva.Animation((frame) => {
        timeBeforeAnimation = frame.time;
        if (timeBeforeAnimation > this.nextCycle) {
          this.nextCycle += this.sliderTime;
          this.changeImageSource(this.source[this.nextImageCount()]);
        }
      }, this.konvaObject.parent);

      this.animation.start();
    }
  }

  stopPreview() {
    if (this.source.length > 1) {
      this.renderChangeImageSource(this.source[0], this.renderObject);

      if (this.animationRender != null && this.animationRender !== undefined) {
        this.animationRender.stop();
      }

      this.nextCycleRender = this.sliderTime;
      this.sliderTimeRender = this.sliderTime;
      this.timeBeforeAnimationRender = 0;
    }
  }

  // Setters
  setSpeed(val) {
    if (val > 1) {
      this.sliderTime = val * 1000;
    } else {
      this.sliderTime = 1000;
    }
  }
}
